// Utils
import { Auth, getCookie, setCookie } from "../lib/cookie";

// Clients
import { AdminClient } from './BackendAdminClient/admin'
import { MicrosoftClient } from './BackendAdminClient/microsoft';
import { MorningCoin } from './BackendAdminClient/morning-coin'
import { Provider } from './BackendAdminClient/provider'
import { Receipt } from './BackendAdminClient/receipt'
import { Report } from './BackendAdminClient/report'
import { Subscriber } from './BackendAdminClient/subscriber'
import { Subscriptions } from './BackendAdminClient/subscriptions'
import { User } from './BackendAdminClient/user'

export class BackendAdminClient {
  get token() {
    return getCookie(Auth.AccessToken);
  }

  set token(accessToken) {
    setCookie(Auth.AccessToken, accessToken);
  }

  get headers() {
    return { Authorization: `Bearer ${this.token}` };
  }

  get backendUrl() {
    return `${process.env.ADMIN_HOST}/ruejai-backend-admin`;
  }

  setToken(accessToken) {
    if (accessToken) {
      this.token = accessToken;

      this.updateHeaders();
    }
  }

  updateHeaders() {
    this.admin.setHeaders(this.headers);
  }

  setToken(accessToken) {
    if (accessToken) {
      this.token = accessToken;

      this.updateHeaders();
    }
  }

  updateHeaders() {
    this.admin.setHeaders(this.headers);
  }

  constructor() {
    // Set api url
    const apiUrl = `${this.backendUrl}/api`;

    // Admin
    this.admin = new AdminClient(apiUrl, this.headers);
    // Auth
    this.auth = new AuthClient(apiUrl);
    // Morning Coin
    this.morningCoin = new MorningCoin(apiUrl, this.headers);
    // Subscriptions
    this.subscriptions = new Subscriptions(apiUrl, this.headers);
    // User
    this.user = new User(apiUrl, this.headers);
    // Provider
    this.provider = new Provider(apiUrl, this.headers);
    // Receipt
    this.receipt = new Receipt(apiUrl, this.headers);
    // Report
    this.report = new Report(apiUrl, this.headers);
    // Subscriber
    this.subscriber = new Subscriber(apiUrl, this.headers);
  }
}

export class AuthClient {
  constructor(apiUrl) {
    // Set auth url
    const authUrl = `${apiUrl}/auth`;

    // Microsoft Client
    this.microsoft = new MicrosoftClient(authUrl);
  }
}



// WEBPACK FOOTER //
// ./src/clients/BackendAdminClient.js